// extracted by mini-css-extract-plugin
export default {"container":"Account_container__-O1lE","info":"Account_info__4OKzr","history":"Account_history__y4R-U"};